export enum ProcedureArticleCodes {
  RELATED_TOPIC = 'procedure_related_topics_detail',
  WHAT_NEXT = 'procedure_what_next_detail',
  ARTICLE = 'procedure_article_detail',
}
